<template>
    <footer
        class="md-footer standard"
        :class="[{ inner: inner }, fixedZindexCls]"
        :style="colorMapStyle"
    >
        <div
            class="footer-container"
            :style="{ backgroundColor: bgColor, color: fontColor }"
        >
            <div class="f-col">
                <div class="top-content">
                    <div class="left-content">
                        <div class="site-logo" v-if="logos.length > 0">
                            <template v-for="(logo, index) in validLogos">
                                <a
                                    v-if="logo.logo.href"
                                    :key="index"
                                    :href="logo.logo.href"
                                    aria-label="site logo"
                                    rel="noopener noreferrer"
                                >
                                    <site-img
                                        class="logo-item"
                                        :src="logo.logo"
                                        alt="site logo"
                                        :style="{ height: size / 100 + 'em' }"
                                        :ssrInitSize="30"
                                        dir="height"
                                    />
                                </a>
                                <site-img
                                    v-else
                                    class="logo-item"
                                    :key="'key-' + index"
                                    :src="logo.logo"
                                    alt="site logo"
                                    :style="{ height: size / 100 + 'em' }"
                                    :ssrInitSize="30"
                                    dir="height"
                                />
                            </template>
                        </div>
                        <div class="detail">
                            <template v-if="companyInfo">
                                <div
                                    v-if="companyInfo.name"
                                    class="co-name"
                                    :style="useBroNameStyle"
                                    v-html="companyInfo.name"
                                ></div>
                            </template>
                            <p class="detail-info">
                                <span
                                    v-if="
                                        !!footerAgentInfo.firstName ||
                                            !!footerAgentInfo.lastName
                                    "
                                    class="detail-name"
                                    :style="useAgentNameStyle"
                                >
                                    {{ footerAgentInfo.firstName || '' }}
                                    {{ footerAgentInfo.lastName || '' }}
                                </span>
                                <span
                                    :style="useAgentLicenseStyle"
                                    v-if="!!footerAgentInfo.license"
                                    class="detail-license"
                                >
                                    {{ global.licenseName }}
                                    {{ footerAgentInfo.license }}
                                </span>
                            </p>
                            <p class="detail-info">
                                <span
                                    v-if="!!footerAgentInfo.phone"
                                    class="detail-phone"
                                    :style="useAgentPhoneStyle"
                                >
                                    <a
                                        :href="'tel:' + footerAgentInfo.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >
                                        {{
                                            $ft.formatPhone(
                                                footerAgentInfo.phone
                                            )
                                        }}
                                    </a>
                                </span>
                                <span
                                    v-if="!!footerAgentInfo.email"
                                    class="detail-email"
                                    :style="useAgentEmailStyle"
                                >
                                    <a
                                        :href="
                                            'mailto:' + footerAgentInfo.email
                                        "
                                        :title="$t('common:link.mailtoTitle')"
                                        :aria-label="
                                            $t('common:link.mailtoAriaLabel', {
                                                email: footerAgentInfo.email
                                            })
                                        "
                                        rel="noopener noreferrer"
                                    >
                                        {{ footerAgentInfo.email }}
                                    </a>
                                </span>
                            </p>
                        </div>
                        <div
                            class="detail subdomain-detail"
                            v-if="subOwnerInfo"
                        >
                            <p class="detail-info subinfo-name">
                                <span
                                    v-if="
                                        !!subOwnerInfo.firstName ||
                                            !!subOwnerInfo.lastName
                                    "
                                    class="detail-name"
                                    :style="useAgentNameStyle"
                                >
                                    {{ subOwnerInfo.firstName || '' }}
                                    {{ subOwnerInfo.lastName || '' }}
                                </span>
                            </p>
                            <p class="detail-info">
                                <span
                                    v-if="!!subOwnerInfo.phone"
                                    class="detail-phone"
                                    :style="useAgentPhoneStyle"
                                >
                                    <a
                                        :href="'tel:' + subOwnerInfo.phone"
                                        target="_top"
                                        rel="noopener noreferrer"
                                    >
                                        {{
                                            $ft.formatPhone(subOwnerInfo.phone)
                                        }}
                                    </a>
                                </span>
                                <span
                                    v-if="!!subOwnerInfo.email"
                                    class="detail-email"
                                    :style="useAgentEmailStyle"
                                >
                                    <a
                                        :href="'mailto:' + subOwnerInfo.email"
                                        :title="$t('common:link.mailtoTitle')"
                                        :aria-label="
                                            $t('common:link.mailtoAriaLabel', {
                                                email: subOwnerInfo.email
                                            })
                                        "
                                        rel="noopener noreferrer"
                                    >
                                        {{ subOwnerInfo.email }}
                                    </a>
                                </span>
                            </p>
                        </div>
                        <div class="detail">
                            <template v-if="getAddressInfo">
                                <div
                                    class="detail-addr"
                                    :style="useBroAddrStyle"
                                    v-html="getAddressInfo"
                                ></div>
                            </template>

                            <template v-if="footerAgentCustomContent">
                                <div
                                    class="custom-content"
                                    v-html="
                                        formatFontSize(footerAgentCustomContent)
                                    "
                                ></div>
                            </template>
                        </div>
                    </div>
                    <div class="right-content">
                        <ul class="main-menu" role="navigation">
                            <li class="first-col">
                                <menu-item
                                    v-for="(menu, index) in firstMenus"
                                    :key="'firstMenu-' + index"
                                    :selfKey="'firstMenu-' + index"
                                    :expandKey="expandKey"
                                    :menu="menu"
                                    :useMenuStyle="useMenuStyle"
                                    :useSubMenuStyle="useSubMenuStyle"
                                    :smallDown="true"
                                    @updateExpandKey="updateExpandKey"
                                />
                            </li>
                            <li class="second-col">
                                <menu-item
                                    v-for="(menu, index) in secondMenus"
                                    :key="'secondMenu-' + index"
                                    :selfKey="'secondMenu-' + index"
                                    :expandKey="expandKey"
                                    :menu="menu"
                                    :useMenuStyle="useMenuStyle"
                                    :useSubMenuStyle="useSubMenuStyle"
                                    :smallDown="true"
                                    @updateExpandKey="updateExpandKey"
                                />
                            </li>
                            <li class="third-col">
                                <menu-item
                                    v-for="(menu, index) in thirdMenus"
                                    :key="'thirdMenu-' + index"
                                    :selfKey="'thirdMenu-' + index"
                                    :expandKey="expandKey"
                                    :menu="menu"
                                    :useMenuStyle="useMenuStyle"
                                    :useSubMenuStyle="useSubMenuStyle"
                                    :smallDown="true"
                                    @updateExpandKey="updateExpandKey"
                                />
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="bottom-content">
                    <closely-app-download useModule="md-footer" />

                    <div class="detail-info">
                        <template v-if="agentHasDisclaimer">
                            <p
                                v-for="(
                                    file, index
                                ) in footerAgentInfo.disclaimerList"
                                :key="index + 'mainfile'"
                                class="detail-file"
                            >
                                <a :href="file.url" rel="noopener noreferrer">
                                    {{ file.name.split('.')[0] }}
                                </a>
                            </p>
                        </template>
                        <!-- sub file -->
                        <template v-if="subOwnerHasDisclaimer">
                            <p
                                v-for="(
                                    file, index
                                ) in subOwnerInfo.disclaimerList"
                                :key="index + 'subfile'"
                                class="detail-file"
                            >
                                <a :href="file.url" rel="noopener noreferrer">
                                    {{ file.name.split('.')[0] }}
                                </a>
                            </p>
                        </template>
                    </div>

                    <div class="no-mls-disclaimer texas-mls" v-if="hasTeaxsMls">
                        <a
                            href="https://www.trec.texas.gov/sites/default/files/pdf-forms/CN%201-3.pdf"
                            target="_blank"
                            :title="$t('md-footer.realEstateConsumer')"
                            rel="noopener noreferrer"
                        >{{ $t('md-footer.realEstateConsumer') }}</a>
                    </div>
                    <div
                        class="no-mls-disclaimer"
                        v-if="noMlsDisclaimers.length > 0"
                    >
                        <div
                            class="claimer"
                            v-for="(noMls, index) in noMlsDisclaimers"
                            :key="index"
                            v-html="noMls.label"
                        ></div>
                    </div>
                    <a class="md-footer_notshare" v-if="isDoNotShareShow" href="/site/dsar">{{ $t('md-footer.doNotShare') }} --&gt; </a>
                    <div
                        v-if="!hideCopyRight"
                        class="copyright"
                        :style="useCopyStyle"
                    >
                        <template v-if="gfFlag != '1'">
                            <p
                                class="cr"
                                v-if="showCopyright"
                                v-html="
                                    $t('md-footer.madeInAndCopyright', {
                                        chimeLink,
                                        year
                                    })
                                "
                            ></p>
                            <p class="ppt">
                                <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                            </p>
                        </template>
                        <p v-else class="cr">
                            {{ $t('md-footer.geographicFarmingLlc', { year }) }}
                            <CopyrightLink :gfFlag="gfFlag" :isShowAccessibility="isShowAccessibility" /> 
                        </p>
                    </div>

                    <MlsDisclaimer
                        v-if="!wordPressSSR"
                        theme="standard"
                        @update="mlsUpdated"
                    />
                    <div
                        v-if="socialNetworksInfo.length > 0"
                        class="share-links"
                    >
                        <a
                            v-for="(social, index) in socialNetworksInfo"
                            :key="social.id + '-' + index"
                            class="share-item"
                            :style="useCopyStyle"
                            :href="social.url"
                            :aria-label="social.socialNetwork"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <i class="iconfont" :class="social.icon"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import common from '../index';
export default {
    mixins: [common],
    data: function() {
        return {};
    },
    computed: {
        firstMenus() {
            return this.z_menus.filter((item, index) => index % 3 === 0);
        },
        secondMenus() {
            return this.z_menus.filter((item, index) => index % 3 === 1);
        },
        thirdMenus() {
            return this.z_menus.filter((item, index) => index % 3 === 2);
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
@import '.././index.scss';

@mixin media-600-footer {
    .f-col {
        .top-content {
            padding-top: 30px;

            .right-content {
                display: none;
            }

            .left-content {
                width: 100%;
                padding-right: 5px;
                padding-top: 0;

                .site-logo {
                    font-size: 30px;
                    justify-content: start;

                    .logo-item {
                        margin-right: 20px;
                        margin-bottom: 20px;
                    }
                }

                .detail {
                    .detail-info {
                        margin-top: 5px;

                        span {
                            word-break: break-word;
                        }

                        .detail-file {
                            font-size: 12px;
                        }
                    }
                }
            }
        }

        .bottom-content {
            margin-top: 0;

            .copyright {
                margin-top: 10px;
                margin-bottom: 10px;
            }

            .share-links {
                .share-item {
                    font-size: 16px;
                    margin-right: 20px;
                    line-height: 1.2;
                    width: 20px;
                    height: 20px;
                    margin-top: 10px;

                    .iconfont {
                        font-size: 16px;
                    }
                }
            }

            .mls-declaimer-container {
                padding-top: 25px;
            }
        }
    }
}

.md-footer.standard {
    .footer-container {
        padding-top: 0;
        padding-bottom: 0px;
        @include color-theme('background-color');
        position: relative;
    }

    &.fixed {
        position: fixed;
        bottom: 0;
        width: 100%;
    }

    .f-col {
        .top-content {
            padding-top: 40px;
            display: flex;

            .left-content {
                width: 40%;
                padding-right: 30px;

                .site-logo {
                    font-size: 40px;
                    overflow: hidden;
                    position: relative;

                    // display: flex;
                    // flex-wrap: wrap;
                    // justify-content: space-between;
                    .logo-item {
                        margin-bottom: 30px;
                        margin-right: 30px;
                        height: 1em;
                    }
                }

                .detail {
                    &.subdomain-detail {
                        margin-top: 10px;

                        .subinfo-name {
                            margin-top: 20px;
                        }
                    }

                    .co-name {
                        font-size: 14px;
                        line-height: 1.43;
                        text-align: left;
                        font-family: var(--font-bold);
                    }

                    .detail-addr {
                        margin-top: 20px;
                        font-size: 14px;
                        line-height: 1.43;
                        text-align: left;
                    }

                    .download-closely {
                        margin-top: 30px;
                        margin-bottom: 40px;

                        .code-wrapper {
                            .android {
                                margin-left: 30px;
                            }

                            .android,
                            .ios {
                                img {
                                    width: 80px;
                                    height: 80px;
                                }
                            }

                            justify-content: flex-start;
                        }
                    }

                    .detail-info {
                        margin-top: 10px;
                        font-size: 14px;
                        line-height: 1.43;
                        text-align: left;

                        .detail-file {
                            cursor: pointer;
                            font-size: 14px;
                            color: #797e8b;
                        }

                        .detail-name,
                        .detail-phone {
                            margin-right: 14px;
                        }

                        > span {
                            display: inline-block;
                            vertical-align: top;
                            word-break: break-word;

                            &:after {
                                content: '|';
                                display: inline-block;
                                font-size: inherit;
                                line-height: 1;
                                height: 14px;
                                position: relative;
                                color: currentColor;
                                left: 7px;
                            }
                        }

                        & > :last-child:after {
                            display: none;
                        }
                    }
                }

                @include no-mls-disclaimer;

                .copyright {
                    font-size: 12px;
                    margin-top: 20px;
                    color: #797e8b;

                    .cr {
                        line-height: 1.67;

                        a {
                            text-decoration: underline;
                        }
                    }

                    .ppt {
                        margin-top: 10px;
                        line-height: 1.67;
                    }
                }
            }

            .right-content {
                width: 60%;
                border-left: 1px solid rgba(255, 255, 255, 0.15);
                background: transparent;

                .main-menu {
                    padding: 0px 54px 40px 40px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    align-items: flex-start;

                    .first-col,
                    .second-col,
                    .third-col {
                        width: 33.3%;

                        ul {
                            margin-bottom: 20px;
                            cursor: pointer;
                            display: block;

                            & > a {
                                display: flex;
                                position: relative;
                                opacity: 0.9;
                                max-width: 100%;
                                @include ellipsis();

                                &:hover {
                                    opacity: 1;
                                }

                                &.hasChild {
                                    display: flex;
                                }
                            }

                            .footer-menu {
                                line-height: 2.15;
                                cursor: pointer;

                                &.down {
                                    font-weight: 600;
                                    opacity: 1;
                                }

                                .icon-arrow-down {
                                    font-size: inherit;
                                    position: relative;
                                    left: 4px;
                                    display: inline-block;
                                    transform: scale(0.7, 0.8);
                                }

                                &.down .icon-arrow-down {
                                    transform: rotate(180deg) scale(0.7, 0.8);
                                }
                            }

                            .footer-submenu {
                                font-size: 12px;

                                .sub-menu {
                                    margin-bottom: 0;
                                    display: block;
                                    line-height: 2.5;

                                    & > a {
                                        display: flex;
                                        position: relative;
                                        // opacity: 0.4;
                                        // &:hover {
                                        //     opacity: 0.7;
                                        // }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .bottom-content {
            margin-top: 50px;
            padding-bottom: 30px;

            .detail-info {
                margin-top: 10px;

                .detail-file {
                    cursor: pointer;
                    font-size: 14px;
                    color: #797e8b;
                }
            }

            .download-closely {
                margin-top: 0;
                margin-bottom: 40px;

                .code-wrapper {
                    justify-content: flex-start;
                }
            }

            .copyright {
                font-size: 12px;
                margin-top: 20px;
                color: #797e8b;

                .cr {
                    line-height: 1.67;

                    a {
                        text-decoration: underline;
                    }
                }

                .ppt {
                    margin-top: 10px;
                    line-height: 1.67;
                    a {
                        white-space: nowrap;
                    }
                }
            }

            .share-links {
                font-size: 0px; // remove inline-block spacing

                .share-item {
                    display: inline-block;
                    font-size: 24px;
                    opacity: 0.6;
                    margin-right: 10px;
                    line-height: 2;
                    width: 48px;
                    height: 48px;
                    text-align: center;

                    &:hover {
                        opacity: 1;
                    }

                    .iconfont {
                        font-size: 24px;
                    }
                }
            }

            @include no-mls-disclaimer;
        }
    }

    .fair-house-logo {
        vertical-align: text-bottom;
        margin: 0 5px;
        padding-top: 5px;
    }

    @include media-1080 {
        .f-col {
            .left-content {
                width: 50%;
                padding: 0 20px 0 0;
            }

            .right-content {
                width: 50%;

                .main-menu {
                    padding: 40px 20px 40px 20px;

                    .first-col,
                    .second-col,
                    .third-col {
                        width: 50%;
                    }
                }
            }
        }
    }

    @include media-800 {
        .f-col {
            .right-content {
                display: none;
            }

            .left-content {
                width: 100%;
                padding: 30px 0 15px 0;

                .detail {
                    .detail-info {
                        margin-top: 4px;

                        .detail-email {
                            display: inline;
                        }
                    }
                }

                .copyright {
                    margin-bottom: 20px;
                }
            }
        }
    }

    @include media-600 {
        @include media-600-footer();
    }

    &.inner {
        @include media-600-footer();
        padding-top: 0;

        &.fixed {
            position: absolute;
            z-index: 1;
        }

        .f-col {
            margin-left: 0;
            margin-right: 0;
            .top-content {
                padding: 50px var(--inner-padding, 20px) 0;
            }
            .bottom-content {
                display: block;
                padding: 0 var(--inner-padding, 20px) 50px;
            }
            .mls-declaimer-container {
                padding-left: 0;
                padding-right: 0;
            }
        }
    }
}
</style>
